import { render } from "./CampaignsPage.vue?vue&type=template&id=6bdead40"
import script from "./CampaignsPage.vue?vue&type=script&lang=js"
export * from "./CampaignsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__